import { useSearchParams } from 'react-router-dom';
import { CreditCard, Home, XCircle } from 'lucide-react';
import { useRouter } from '@repo/ui/hooks/use-router';

export default function PaymentCancelPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const router = useRouter();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* Cancel Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
            <XCircle className="h-8 w-8 text-red-600" />
          </div>

          {/* Cancel Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Paiement annulé
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>

          {/* Session ID Display */}
          {sessionId && (
            <div className="bg-white rounded-lg border border-gray-200 p-4 mb-8">
              <div className="flex items-center justify-center mb-2">
                <CreditCard className="h-5 w-5 text-gray-400 mr-2" />
                <span className="text-sm font-medium text-gray-700">
                  ID de session
                </span>
              </div>
              <p className="text-xs text-gray-500 font-mono break-all">
                {sessionId}
              </p>
            </div>
          )}

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={() => {
                router.push('/admin/account');
              }}
              className="w-full flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              <CreditCard className="h-5 w-5 mr-2" />
              Réessayer le paiement
            </button>

            <button
              onClick={() => {
                router.push('/home');
              }}
              className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              <Home className="h-5 w-5 mr-2" />
              Retour à l'accueil
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Vous pouvez réessayer votre paiement à tout moment.
            </p>
            <p className="text-sm text-gray-500 mt-1">
              En cas de problème, contactez notre support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}